import jStat from 'jstat';

export interface MedianResult {
  median: number;
  data: number[];
  interpretation: string;
}

export function calculateMedian(data: number[]): MedianResult {
  // Handle empty array or invalid data
  if (!data || data.length === 0) {
    return {
      median: 0,
      data: [],
      interpretation: 'No data available for median calculation.'
    };
  }

  // Handle single value
  if (data.length === 1) {
    const value = data[0]!;
    return {
      median: value,
      data: [value],
      interpretation: `Single value dataset: median equals ${value}.`
    };
  }

  const sortedData = [...data].sort((a, b) => a - b);
  const median = jStat.median(sortedData);

  // Ensure median is a valid number
  const validMedian = Number.isFinite(median) ? median : 0;

  return {
    median: validMedian,
    data: sortedData,
    interpretation: `The median value is ${validMedian.toFixed(2)}, with equal numbers of values above and below it.`
  };
} 